import AuthPage from "./AuthPage";
import React, { useState } from 'react';
import SendMessageButton from './SendMessageButton';
import Groups, { Group } from './Groups';
import './MainPage.css';
import './RoundUpWelcomePage.css';

const RoundUpWelcomePage = () => {
    return (
        <div className="roundUpWelcomePage">
            <h1>Welcome to Round Up!</h1>
            <h3>Tired of being added to massive random group chats just to play pickup basketball or soccer? </h3>
            <h3>Round Up is a FREE service that allows you to easily store and text notify different groups of friends individually & seperately when you go to play pickup or have small impromptu events.</h3>
            <AuthPage></AuthPage>
        </div>
    );
};

export default RoundUpWelcomePage;
